export default __webpack_public_path__ + "static/media/facebook.0f03e0f6.svg";